import React from "react";
import ReactLoading from "react-loading";

const Loading = ({ type, color, width = 375, height = 667 , className }) => {
  return (
    <ReactLoading
      type={type}
      color={color}
      height={width}
      width={height}
      className={`loader-box ${className}`}
    />
  );
};

export default Loading;
